import { Container, Paper, Typography } from '@mui/material';
import AuthWrapper1 from 'views/authentication/AuthWrapper1';
import TwoFactorSetupForm from './TwoFactorSetupForm';

const TwoFactorSetupPage = () => (
  <AuthWrapper1>
    <Container maxWidth="xs" sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Paper elevation={3} sx={{ p: 4, width: '100%' }}>
        <Typography component="h1" variant="h5" align="center" gutterBottom>
          Set Up Two-Factor Authentication
        </Typography>
        <TwoFactorSetupForm />
      </Paper>
    </Container>
  </AuthWrapper1>
);

export default TwoFactorSetupPage;
